<template>
	<el-container class="app-layout">
		<Sidebar style=" flex-shrink: 0;" />
		<el-container direction="vertical">
			<el-header style="padding: 0; flex-shrink: 0;">
				<Header />
			</el-header>
			<el-main>
				<router-view />
			</el-main>
		</el-container>
	</el-container>
</template>
<script>
// 2. 导入组件
import Sidebar from '@/common/Sidebar.vue'; // 注意路径要写对
import Header from '@/common/Header.vue';

export default {
	components: {
		Sidebar, // 3. 注册组件
		Header
	},
}
</script>
<style>
.app-layout {
	height: 100vh;
	background-color: #f5f7fa;
}

.el-main {
	padding: 20px;
	background-color: #f5f7fa;
	flex: 1;
	min-width: 1000px;
	overflow: auto;
}
</style>